module.exports = __webpack_public_path__ + "static/media/HighFive_LockUp_NoSwoosh.d17cbb03.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/HighFive_LockUp_NoSwoosh.svg
// module id = 973
// module chunks = 0